<template>
  <wo-region v-if="user">
    <wo-layout>
      <wo-title tag-name="h3">{{ user.display_name }}</wo-title>
    </wo-layout>
    <wo-layout>
      <wo-grid>
        <wo-column width-lg="8">
          <user-props :value="user" :admin-mode="true">
            <po-route-link :value="editRoute" v-t="'general.action.edit'" slot="actions" />
            <po-action-dropdown :actions="actions" slot="actions" mod-right @execute="executeAction" />
          </user-props>
        </wo-column>
        <wo-column width-lg="4">
          <user-contact-props :value="user" />
          <wo-spacer />
          <credential-list v-if="credentials" :credentials="credentials.items" :user="user" @update="loadCredentials" />
        </wo-column>
      </wo-grid>
    </wo-layout>
  </wo-region>
</template>

<script>

import { mapState } from 'vuex'
import { userRepository, credentialsRepository } from '@/repository/identity'

import { ADMIN_USER_EDIT } from '@/routes/admin'

import UserProps from '@/components/identity/UserProps'
import UserContactProps from '@/components/identity/UserContactProps'
import CredentialList from '@/components/identity/CredentialList'
import UserCompanyUpdateModal from '@/components/identity/UserCompanyUpdateModal'
import UserRoleUpdateModal from '@/components/identity/UserRoleUpdateModal'

import { UserStatusEnum } from '@/model/identity'
import { Entities } from '@/model/util'

import { showConfirmation, showModal } from '@/modal'

const activeAction = {
  action: 'activate',
  labelKey: 'admin.user.action.activate',
  icon: 'user-add',
  confirm: { messageKey: 'admin.user.confirmActivate' }
}

const inActiveAction = {
  action: 'inactivate',
  labelKey: 'admin.user.action.inactivate',
  icon: 'user-remove',
  confirm: { messageKey: 'admin.user.confirmInactivate' }
}

const updateCompanyAction = {
  labelKey: 'admin.user.action.updateCompany',
  icon: 'loop',
  component: UserCompanyUpdateModal
}

const updateRoleAction = {
  labelKey: 'admin.user.action.updateRole',
  icon: 'gear',
  component: UserRoleUpdateModal
}

export default {
  components: { UserProps, UserContactProps, CredentialList },
  props: {
    userId: [Number, String]
  },
  computed: mapState({
    user: state => state.identity.user,
    credentials: state => state.identity.userCredentialList,
    editRoute () {
      return { name: ADMIN_USER_EDIT }
    },
    actions () {
      const actions = [updateCompanyAction, updateRoleAction]
      if (Entities.areEqual(this.user.status, UserStatusEnum.values.ACTIVE)) {
        actions.push(inActiveAction)
      } else {
        actions.push(activeAction)
      }
      return actions
    }
  }),
  created () {
    this.loadUser()
  },
  methods: {
    loadUser () {
      this.$store.dispatch(userRepository.find, { id: this.userId })
      this.loadCredentials()
    },
    loadCredentials () {
      this.$store.dispatch(credentialsRepository.findAll, { filter: { user_id: this.userId } })
    },
    executeAction (action) {
      if (action.component) {
        showModal(action.component, { user: this.user })
          .catch(e => {})
      } else {
        showConfirmation(action.confirm, () => this.doAction(action))
      }
    },
    doAction (action) {
      const payload = {
        action: action.action
      }
      return this.$store.dispatch(userRepository.execute, { entity: this.user, action: payload })
    }
  }
}
</script>
